import { h } from "vue";

import type { Component } from "vue";

import { isEmbedded } from "@/remote/contract";

/**
 * Every modal in the app teleports to the host's `<body>`, outside both custom elements, where the
 * scoped base layer (postcss/scope-base-layer.mjs) no longer reaches it. `cl-modal` is registered
 * once in app-setup, so wrapping it there covers all 39 call sites. Standalone is a no-op.
 */
export const withRemoteScope = (component: Component): Component =>
  isEmbedded()
    ? {
        name: "ClModalWithRemoteScope",
        inheritAttrs: false,
        setup(_props, { attrs, slots }) {
          return () =>
            h(
              component,
              { ...attrs, class: [attrs.class, "titan-remote-scope"] },
              slots,
            );
        },
      }
    : component;

export default withRemoteScope;
